export const createIdempotencyKey = (prefix = 'submission') => {
  const randomUuid = globalThis.crypto?.randomUUID?.();
  if (randomUuid) return `${prefix}-${randomUuid}`;

  // Idempotency needs practical uniqueness, not secrecy. This fallback covers
  // older browser/test environments without crypto.randomUUID().
  const randomPart = Math.random().toString(36).slice(2);
  return `${prefix}-${Date.now().toString(36)}-${randomPart}`;
};
